export const API_ENDPOINTS = {
    // Switch between Airtable (event_attendance) and Google Sheets (event_attendance_gsheets)
    EVENT_ATTENDANCE: "/api/event_attendance_gsheets"
};
